import { dataHealthService } from "../services/dataHealthService";
import { useAsyncData } from "./useAsyncData";

export function useDataHealth() {
  return useAsyncData(() => dataHealthService.getChecks(), []);
}
